export const detectUrl = (text) => {
  const regex = /(https?:\/\/[^\s]+)/g;
  return text?.match(regex);
};
